import { render, staticRenderFns } from "./QutaParameter.vue?vue&type=template&id=8d1c6012&scoped=true&"
import script from "./QutaParameter.vue?vue&type=script&lang=js&"
export * from "./QutaParameter.vue?vue&type=script&lang=js&"
import style0 from "./QutaParameter.vue?vue&type=style&index=0&id=8d1c6012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1c6012",
  null
  
)

export default component.exports